"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.Builder = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _settings = require("./settings.js");
var _cccisdSurveyCommon = require("cccisd-survey-common");
var _cccisdReduxFormHelpers = require("cccisd-redux-form-helpers");
var _cccisdWysiwyg = _interopRequireDefault(require("cccisd-wysiwyg"));
var _common = _interopRequireDefault(require("cccisd-survey-common/dist/styles/common.css"));
var _question = _interopRequireDefault(require("cccisd-icons/question4"));
var _cccisdTooltip = _interopRequireDefault(require("cccisd-tooltip"));
var _style = _interopRequireDefault(require("./style.css"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var afterCompletionOptions = [{
  value: 'return',
  label: 'returns to the menu'
}, {
  value: 'advance',
  label: 'advances past the menu'
}];
var layoutTypeOptions = [{
  value: 'grid',
  label: 'Grid'
}, {
  value: 'circle',
  label: 'Circle'
}];
var shapeOptions = [{
  value: 'square',
  label: 'Square'
}, {
  value: 'rectangle',
  label: 'Rectangle'
}, {
  value: 'circle',
  label: 'Circle'
}];
var Builder = /*#__PURE__*/function (_React$Component) {
  _inherits(Builder, _React$Component);
  var _super = _createSuper(Builder);
  function Builder() {
    _classCallCheck(this, Builder);
    return _super.apply(this, arguments);
  }
  _createClass(Builder, [{
    key: "render",
    value: function render() {
      var _this$props$fields = this.props.fields,
        name = _this$props$fields.name,
        question = _this$props$fields.question,
        description = _this$props$fields.description,
        completeCondition = _this$props$fields.completeCondition,
        afterCompletion = _this$props$fields.afterCompletion,
        minimumNumber = _this$props$fields.minimumNumber,
        shape = _this$props$fields.shape,
        showItemAs = _this$props$fields.showItemAs,
        layoutType = _this$props$fields.layoutType;
      return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_cccisdSurveyCommon.TextBlock, {
        field: name,
        label: "Name"
      }), /*#__PURE__*/_react["default"].createElement(_cccisdSurveyCommon.FieldBlock, {
        field: question,
        label: "Question"
      }, /*#__PURE__*/_react["default"].createElement(_cccisdWysiwyg["default"], {
        content: question.value,
        onChange: question.onChange
      })), /*#__PURE__*/_react["default"].createElement(_cccisdSurveyCommon.FieldBlock, {
        field: description,
        label: "Description"
      }, /*#__PURE__*/_react["default"].createElement(_cccisdWysiwyg["default"], {
        content: description.value,
        onChange: description.onChange
      })), /*#__PURE__*/_react["default"].createElement(_cccisdSurveyCommon.FormBlock, {
        title: "Formatting",
        type: this.props.formBlockType,
        show: true
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "checkbox",
        style: {
          marginTop: 0
        }
      }, /*#__PURE__*/_react["default"].createElement("label", null, /*#__PURE__*/_react["default"].createElement("input", {
        type: "checkbox",
        checked: showItemAs.value === 'image',
        onChange: function onChange() {
          return showItemAs.onChange(showItemAs.value === 'image' ? 'text' : 'image');
        }
      }), ' ', "Emphasize image", ' ', /*#__PURE__*/_react["default"].createElement(_cccisdTooltip["default"], {
        title: "Select this box if you want to show text below each image"
      }, /*#__PURE__*/_react["default"].createElement(_question["default"], null)))), /*#__PURE__*/_react["default"].createElement(_cccisdSurveyCommon.FieldBlock, {
        field: shape,
        label: /*#__PURE__*/_react["default"].createElement("span", null, "Shape:", ' ', /*#__PURE__*/_react["default"].createElement(_cccisdTooltip["default"], {
          title: "Circle shapes work best for the circle layout."
        }, /*#__PURE__*/_react["default"].createElement(_question["default"], null)))
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].indent
      }, shapeOptions.map(function (option, index) {
        return /*#__PURE__*/_react["default"].createElement("label", {
          key: option.value,
          className: "radio-inline"
        }, /*#__PURE__*/_react["default"].createElement("input", _extends({
          type: "radio"
        }, (0, _cccisdReduxFormHelpers.domOnlyProps)(shape), {
          value: option.value,
          checked: shape.value === option.value
        })), ' ', option.label);
      }))), /*#__PURE__*/_react["default"].createElement("div", {
        className: _common["default"].lastRow
      }, /*#__PURE__*/_react["default"].createElement(_cccisdSurveyCommon.FieldBlock, {
        field: layoutType,
        label: /*#__PURE__*/_react["default"].createElement("span", null, "Layout:", ' ', /*#__PURE__*/_react["default"].createElement(_cccisdTooltip["default"], {
          title: "Circle layout works best with an odd number items and circle shapes."
        }, /*#__PURE__*/_react["default"].createElement(_question["default"], null)))
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].indent
      }, layoutTypeOptions.map(function (option, index) {
        return /*#__PURE__*/_react["default"].createElement("label", {
          key: option.value,
          className: "radio-inline"
        }, /*#__PURE__*/_react["default"].createElement("input", _extends({
          type: "radio"
        }, (0, _cccisdReduxFormHelpers.domOnlyProps)(layoutType), {
          value: option.value,
          checked: layoutType.value === option.value
        })), ' ', option.label);
      }))))), /*#__PURE__*/_react["default"].createElement(_cccisdSurveyCommon.FormBlock, {
        title: "Advancing",
        type: this.props.formBlockType,
        show: true
      }, /*#__PURE__*/_react["default"].createElement(_cccisdSurveyCommon.FieldBlock, {
        field: completeCondition,
        label: "Before advancing, must complete:"
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].indent
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "radio",
        style: {
          marginTop: 0
        }
      }, /*#__PURE__*/_react["default"].createElement("label", null, /*#__PURE__*/_react["default"].createElement("input", _extends({
        type: "radio"
      }, (0, _cccisdReduxFormHelpers.domOnlyProps)(completeCondition), {
        value: "all",
        checked: completeCondition.value === 'all'
      })), ' ', "all menu options")), /*#__PURE__*/_react["default"].createElement("div", {
        className: "radio"
      }, /*#__PURE__*/_react["default"].createElement("label", null, /*#__PURE__*/_react["default"].createElement("input", _extends({
        type: "radio"
      }, (0, _cccisdReduxFormHelpers.domOnlyProps)(completeCondition), {
        value: "minimum",
        checked: completeCondition.value === 'minimum'
      })), ' ', "at least", ' ', /*#__PURE__*/_react["default"].createElement("input", _extends({
        className: "form-control input-sm",
        style: {
          display: 'inline-block',
          width: '60px',
          height: '1.8em'
        },
        type: "number"
      }, (0, _cccisdReduxFormHelpers.domOnlyProps)(minimumNumber))), ' ', "menu option(s)")), /*#__PURE__*/_react["default"].createElement("div", {
        className: "radio"
      }, /*#__PURE__*/_react["default"].createElement("label", null, /*#__PURE__*/_react["default"].createElement("input", _extends({
        type: "radio"
      }, (0, _cccisdReduxFormHelpers.domOnlyProps)(completeCondition), {
        value: "none",
        checked: completeCondition.value === 'none'
      })), ' ', "no menu options")))), /*#__PURE__*/_react["default"].createElement("div", {
        className: _common["default"].lastRow
      }, /*#__PURE__*/_react["default"].createElement(_cccisdSurveyCommon.FieldBlock, {
        field: afterCompletion,
        label: "On completing the required number of options, the course:"
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].indent
      }, afterCompletionOptions.map(function (option, index) {
        return /*#__PURE__*/_react["default"].createElement("div", {
          key: option.value,
          className: "radio",
          style: index === 0 ? {
            marginTop: 0
          } : {}
        }, /*#__PURE__*/_react["default"].createElement("label", null, /*#__PURE__*/_react["default"].createElement("input", _extends({
          type: "radio"
        }, (0, _cccisdReduxFormHelpers.domOnlyProps)(afterCompletion), {
          value: option.value,
          checked: afterCompletion.value === option.value
        })), ' ', option.label));
      }))))));
    }
  }]);
  return Builder;
}(_react["default"].Component);
exports.Builder = Builder;
_defineProperty(Builder, "propTypes", {
  fields: _propTypes["default"].object
});
var _default = (0, _cccisdSurveyCommon.builderWrapper)({
  fields: _settings.fields,
  validate: _settings.validate,
  initialValues: _settings.initialValues,
  withTemplate: true,
  withAdjustedPlayerSettings: true
})(Builder);
exports["default"] = _default;